import { isEmpty } from "lodash-es";
import { ValidateResult } from "react-hook-form";
import * as yup from "yup";

import { InputMaybe } from "../generated/types";

export function createNonEmptyStringValidator(message = "Cannot be empty"): (value: string) => ValidateResult {
    return (value) => {
        if (isEmpty(value.trim())) {
            return message;
        }

        return true;
    };
}

export function createNoExclusivelyNumericValidator(
    message = "Please enter a valid value",
    allowEmpty?: boolean,
): (value: InputMaybe<string> | undefined) => ValidateResult {
    return (value) => {
        if (value == null || isEmpty(value.trim())) {
            if (allowEmpty) {
                return true;
            }

            return message;
        }

        if (/^\d+$/.test(value.trim())) {
            return message;
        }

        return true;
    };
}

export function validateNoInitials(value: InputMaybe<string> | undefined): ValidateResult {
    if (value == null || isEmpty(value.trim())) {
        return "Cannot be empty";
    }

    const trimmedValue = value.trim();
    if (trimmedValue.length < 2 || (trimmedValue.length === 2 && trimmedValue[1] === ".")) {
        return "Must be a full name, not initials";
    }

    return true;
}

export const fullNameRequired: yup.TestConfig<string | undefined> = {
    message: "Please enter a valid name",
    test: (value) => validateNoInitials(value ?? "") === true,
};

export const validateNoNumbers = (value: InputMaybe<string> | undefined): ValidateResult => {
    if (value == null || isEmpty(value.trim())) {
        return "Cannot be empty";
    }
    if (/\d/.test(value.trim())) {
        return "Cannot contain numbers";
    }

    return true;
};

export const noNumbersAllowed: yup.TestConfig<string | undefined> = {
    message: "Cannot contain numbers",
    test: (value) => validateNoNumbers(value ?? "") === true,
};

export const noExclusivelyNumbersAllowed: yup.TestConfig<string | undefined> = {
    message: "Cannot be exclusively numbers",
    test: (value) => createNoExclusivelyNumericValidator("Please enter a valid value", true)(value) === true,
};
